class CollectionViewSwitch extends HTMLElement {
  constructor() {
    super();
    this.gridButton = this.querySelector('[data-view="grid"]');
    this.listButton = this.querySelector('[data-view="list"]');
    this.gridView = document.getElementById('ProductGridContainer');
    this.listView = document.getElementById('product-list-container');
    
    this.gridButton.addEventListener('click', this.switchToGrid.bind(this));
    this.listButton.addEventListener('click', this.switchToList.bind(this));
    
    // Check localStorage for saved view preference
    const savedView = localStorage.getItem('collectionViewPreference');
    if (savedView === 'list') {
      this.switchToList();
    } else {
      this.switchToGrid();
    }
  }
  
  switchToGrid() {
    this.gridButton.classList.add('active');
    this.listButton.classList.remove('active');
    this.gridView.classList.remove('hidden');
    this.listView.classList.remove('active');
    localStorage.setItem('collectionViewPreference', 'grid');
  }
  
  switchToList() {
    this.listButton.classList.add('active');
    this.gridButton.classList.remove('active');
    this.gridView.classList.add('hidden');
    this.listView.classList.add('active');
    localStorage.setItem('collectionViewPreference', 'list');
  }
}

customElements.define('collection-view-switch', CollectionViewSwitch); 